export class LookupModel {
  id: number;
  name: string;
}
